import React from 'react';
import SvgIcon from 'src/react_components/svg-icon';

interface Props {
  message: string,
  className?: string
}

const QAAlertMessage: React.FC<Props> = ({ message, className = '' }) => (
  <div className={`qa-alert-message ${className}`}>
    <SvgIcon icon="warning" className="icon-md" />
    <span>{message}</span>
  </div>
);

export default QAAlertMessage;
